/* QUARXERY landing — JS
   1) Botón de sonido de los videos (autoplay mudo + toca para oír).
   2) Selector de bundle (.nx-offer): marca .sel y sincroniza variante+cantidad.
   3) quarxeryTriggerCOD(): abre el modal Releasit COD con la variante activa.
   Patrón per-unit (precio variante = por unidad, qty = unidades del bundle).
   Releasit lee input[name="quantity"] del DOM al disparar. Click NATIVO del
   botón Releasit (NO _rsiV2.setState como primer path). Ver
   memory/project_bundles_as_variants + project_releasit_cod_pattern. */

/* ---------- 1) Videos: tap para reproducir (lazy, no autoplay = LCP rápido) ---------- */
window.nxPlay = function (id, box) {
  var v = document.getElementById(id);
  if (!v) return;
  document.querySelectorAll('.quarxery-landing video').forEach(function (o) {
    if (o !== v) { o.pause(); if (o.parentNode) o.parentNode.classList.remove('nx-playing'); }
  });
  if (v.paused) {
    v.muted = false;
    v.play().catch(function () { v.muted = true; v.play().catch(function(){}); });
    box.classList.add('nx-playing');
  } else {
    v.pause();
    box.classList.remove('nx-playing');
  }
};

/* ---------- 2) + 3) Bundles + Releasit COD ---------- */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function bundleQty(el) {
    var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
    return q && q > 0 ? q : 1;
  }

  function selectBundle(el) {
    var id = el.getAttribute('data-bundle-variant-id');
    document.querySelectorAll('.nx-offer').forEach(function (x) { x.classList.remove('sel'); });
    el.classList.add('sel');
    var radio = el.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    if (!id) return;
    selectedVariantId = id;
    selectedQty = bundleQty(el);
    setVariantOnAllForms(id, selectedQty);
  }

  var opts = document.querySelectorAll('.nx-offer');
  opts.forEach(function (el) {
    el.addEventListener('click', function () { selectBundle(el); });
  });

  // Init: bundle marcado .sel (o el primero)
  (function initSelected() {
    var active = document.querySelector('.nx-offer.sel[data-bundle-variant-id]') || opts[0];
    if (active) {
      selectedVariantId = active.getAttribute('data-bundle-variant-id');
      selectedQty = bundleQty(active);
      setVariantOnAllForms(selectedVariantId, selectedQty);
    }
  })();

  window.quarxeryTriggerCOD = function (btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(function () {
      var releasitBtn = findReleasitButton();
      if (releasitBtn) { releasitBtn.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
